import React, { useContext, useEffect, useState } from "react"
import { useLocation } from "@reach/router"
import { Link } from "gatsby"
import { Img } from "react-image"
import Logo from "../../assets/img/kudabank-logo.inline.svg"
import MfbLogo from "../../assets/img/kuda-mfb-logo.inline.svg"
import BusinessKuda from "../../assets/img/kudabusiness-logo.inline.svg"
import Drop from "../../assets/img/drop.inline.svg"
import DarkDropdown from "../../assets/img/dropdown.svg"
import { StateContext } from "../../contextApi"
import NaijaActive from "../../assets/img/flags/naijaActive.inline.svg"
import Canada from "../../assets/img/flags/canada.inline.svg"
import UnitedKingdom from "../../assets/img/flags/uk.inline.svg"
import Uganda from "../../assets/img/flags/uganda.inline.svg"
import Ghana from "../../assets/img/flags/ghana.inline.svg"
import Globe from "../../assets/img/global/globe.inline.svg"
import Global from "../../assets/img/global/globe.inline.svg"
import UkHeaderOptions from "./ukHeaderOptions"
import NgGlobalHeaderOptions from "./ngGlobalHeaderOptions"
import QrModal from "../modals/QRModal"
import { K4bHeaderButton } from "../body/pages/general/K4bCtaHeaderButton"
import { getStoredUTMParams, trackGTMClick } from "../../util/util"

const defaultModals = { menuModal: false, qrModal: false }
const AuthHeaderLayout = ({ isMobile, setSelectedCountry, selectCountry }) => {
  // eslint-disable-next-line no-empty-pattern
  const [modalDefault, setModalOpen] = useState({ ...defaultModals })
  const location = useLocation()
  const [isBusiness, setIsBusiness] = useState(false)
  const [textColor, setTextColor] = useState("color-primary")
  const [ambassador, setAmbassador] = useState(false)
  const [selectedArr, setSelectedArr] = useState([])
  const [selected, setSelected] = useState(0)
  const [selectedItem, setSelectedItem] = useState("Nigeria")

  const [{}, dispatch] = useContext(StateContext)
  const utmParams = getStoredUTMParams()
  const hasUTM = Object.keys(utmParams).length > 0

  const toggleMenu = () => {
    const header = document.querySelector("header")
    header.classList.add("menu-state--active")
  }
  const handleToggle = () => {
    dispatch({
      newMobile: true,
      type: "CHANGE_MOBILE",
    })
  }
  const setModal = key =>
    setModalOpen(state => ({ ...state, [key]: !modalDefault[key] }))
  const setMenuModal = value =>
    setModalOpen(state => ({ ...state, ["menuModal"]: value }))

  const countries = [
    {
      name: "Global",
      icon: <Globe />,
      link: "/global/",
      active: true,
      img: true,
    },
    {
      name: "Nigeria",
      icon: <NaijaActive />,
      link: "/en-ng/",
      active: true,
      img: false,
    },
    {
      name: "United Kingdom",
      icon: <UnitedKingdom />,
      link: "/en-gb/",
      active: true,
      img: false,
    },
    {
      name: "Canada",
      icon: <Canada />,
      link: "/en-ca/",
      active: true,
      img: false,
    },
    { name: "Ghana", icon: <Ghana />, active: false, img: false },
    { name: "Uganda", icon: <Uganda />, active: false, img: false },
  ]

  const renderText = () => {
    switch (selectedItem) {
      case "Global":
        return "You’re currently on our Global page."
      case "Nigeria":
        return "You’re currently viewing Nigerian content."
      case "United Kingdom":
        return "You’re currently viewing United Kingdom content"
      case "Canada":
        return "You’re currently on our Canada page."
      default:
        return "You’re currently on our Global page."
    }
  }
  const renderDropdownIcon = () => {
    return isBusiness ? <Img src={DarkDropdown} /> : <Drop />
  }
  const renderLogo = () => {
    let route = "/"
    switch (selectedItem) {
      case "Nigeria":
        route = "/en-ng/"
        break
      
     
      default:
        route = selectedItem==="Canada"? "/en-ca/":"/en-gb/"
        return  <div className="kuda-brand">
        <Link
          exact="true"
          aria-label="Kuda logo"
          to={isBusiness ? "/en-ng/business/" : route}
        >
          {isBusiness ? <BusinessKuda /> : <Logo />}
        </Link>
      </div>
    }
    return (
      <div >
        <Link
          exact="true"
          aria-label="Kuda logo"
          to={isBusiness ? "/en-ng/business/" : route}
        >
          {isBusiness ?<div className="kuda-brand">
             <BusinessKuda /> 
          </div>: <MfbLogo />}
        </Link>
      </div>
    )
  }

  const renderIcon = () => {
    switch (selectedItem) {
      case "Global":
        return <Globe />
      case "Nigeria":
        return <NaijaActive />
      case "United Kingdom":
        return <UnitedKingdom />
      case "Canada":
        return <Canada />
      default:
        return <Globe />
    }
  }

  const toggleActiveItem = (index, item) => {
    if (countries.includes(index)) {
      setSelectedArr(item.filter(i => i !== index))
      setSelected(index)
      setSelectedItem(item.name)
      selectCountry(item.name)
    } else {
      setSelectedArr([...selectedArr, index])
      setSelected(index)
      setSelectedItem(item.name)
      selectCountry(item.name)
      localStorage.setItem("selectedCountryIndex", index)
      localStorage.setItem("selectedCountry", item.name)
      const header = document.querySelector("header")
      header.classList.add("menu-state--active")
    }
  }

  const removeMenu = () => {
    const header = document.querySelector("header")
    header.classList.remove("menu-state--active")
    setMenuModal(true)
  }

  const close = () => {
    setMenuModal(false)
    document.body.classList.remove("backdrop-init")
  }

  const closeModal = () => {
    setMenuModal(false)
    localStorage.setItem("kuda-country-accepted", true)
    document.body.classList.remove("backdrop-init")
  }

  const [locationState, setLocation] = useState("")
  const countryPathname = () => {
    const pathName = location.pathname
    setLocation(pathName)
  }

  useEffect(() => {
    if (
      location.pathname.includes("fireboy") ||
      location.pathname.includes("erica")
    ) {
      setAmbassador(true)
    } else {
      setAmbassador(false)
    }
  }, [])

  useEffect(() => {
    if (
      location?.pathname.includes("/en-ng/business") ||
      location?.pathname.includes("/kuda-for-her") ||
      location?.pathname.includes("/joinkudabusiness")
    ) {
      setIsBusiness(true)
      setTextColor("color-black")
    } else {
      setTextColor("color-primary")
      setIsBusiness(false)
    }
  }, [location?.pathname])

  useEffect(() => {
    let modalValue = localStorage.getItem("kuda-country-accepted")
    if (!modalValue) {
      setMenuModal(true)
      document.body.classList.add("backdrop-init")
    } else {
      setMenuModal(false)
      document.body.classList.remove("backdrop-init")
    }
  }, [])

  useEffect(() => {
    const countryIndex = localStorage.getItem("selectedCountryIndex")
    const country = localStorage.getItem("selectedCountry")
    setSelected(parseInt(countryIndex))
    setSelectedItem(country)

    selectCountry(country)
  }, [])

  useEffect(() => {
    countryPathname()
    if (locationState.includes("/en-ng/") || locationState === "/") {
      setSelectedArr([...selectedArr, 1])
      setSelected(1)
      setSelectedItem(countries[1].name)
      selectCountry(countries[1].name)
    } else if (location?.pathname.includes("/en-gb/")) {
      setSelectedArr([...selectedArr, 2])
      setSelected(2)
      setSelectedItem(countries[2].name)
      selectCountry(countries[2].name)
    } else if (location?.pathname.includes("/en-ca/")) {
      setSelectedArr([...selectedArr, 3])
      setSelected(3)
      setSelectedItem(countries[3].name)
      selectCountry(countries[3].name)
    } else if (
      location?.pathname.includes("/scam-awareness/") ||
      location?.pathname.includes("/contact/") ||
      location?.pathname.includes("/security/")
    ) {
    } else {
      setSelectedArr([...selectedArr, 0])
      setSelected(0)
      setSelectedItem(countries[0].name)
      selectCountry(countries[0].name)
    }
  }, [locationState])

  return (
    <header className="kuda-header align-center flex">
      <div className="flex justify-between align-center column--100 kuda-header--wrap">
        <div className="kuda-header--main flex align-center">
          {renderLogo()}
          {(() => {
            switch (selectedItem) {
              case "United Kingdom":
                return (
                  <UkHeaderOptions
                    renderDropdownIcon={() => renderDropdownIcon()}
                    removeMenu={removeMenu}
                    textColor={textColor}
                    toggleMenu={toggleMenu}
                    isBusiness
                  />
                )

              default:
                return (
                  <NgGlobalHeaderOptions
                    renderDropdownIcon={() => renderDropdownIcon()}
                    removeMenu={removeMenu}
                    textColor={textColor}
                    toggleMenu={toggleMenu}
                    isBusiness
                    pathname={locationState}
                    selectCountry={selectedItem}
                  />
                )
            }
          })()}
        </div>
        <div
          className="kuda-header--extras flex align-center"
          onMouseEnter={removeMenu}
        >
          <a
            href={
              isBusiness
                ? "https://business.kuda.com/login/"
                : hasUTM
                ? `${process.env.RETAIL_SIGNIN_LINK}/${
                    `${process.env.RETAIL_SIGNIN_LINK}/`.includes("?")
                      ? "&"
                      : "?"
                  }${new URLSearchParams(utmParams).toString()}`
                : `${process.env.RETAIL_SIGNIN_LINK}/`
            }
            target="_blank"
            rel="noopener noreferrer"
            className={`text-bold kuda-cta-wide kuda-nav cta_button ${textColor}`}
            onClick={() =>
              trackGTMClick({
                eventName: "cta_to_app_clicked",
                cta_text: "Sign In",
                path: window.location.pathname,
              })
            }
          >
            Sign In
          </a>
          {!ambassador ? (
            <>
              {isBusiness ? (
                <K4bHeaderButton />
              ) : (
                <>
                  {locationState === "/joinKuda/" ? (
                    <button
                      onClick={() => setModal("qrModal")}
                      className={`kuda-cta-outline  kuda_web`}
                    >
                      Scan Below
                    </button>
                  ) : (
                    <Link
                      to="/joinKuda/"
                      className={`kuda-cta kuda_web`}
                      onClick={() =>
                        trackGTMClick({
                          eventName: "cta_to_app_clicked",
                          cta_text: "Join Kuda",
                          path: window.location.pathname,
                        })
                      }
                    >
                      Join Kuda
                    </Link>
                  )}
                </>
              )}
            </>
          ) : (
            <a
              href="https://kuda.onelink.me/abUI/fireboy/"
              className="kuda-cta kuda_web"
              target="_blank"
              rel="nofollow noopener noreferrer"
              onClick={() =>
                trackGTMClick({
                  eventName: "cta_to_app_clicked",
                  cta_text: "Join Kuda",
                  path: window.location.pathname,
                })
              }
            >
              Join Kuda
            </a>
          )}
        </div>

        <div className="kuda-nav--menu has-left--margin" data-toggle="dropdown">
          <div
            className="color-primary no-link flex align-center"
            to="/help/"
            onMouseEnter={removeMenu}
            onClick={removeMenu}
          >
            <div className="dropDown flex global-drop">
              {renderIcon()}
              {/* <img src={renderIcon()} alt="logo"/> */}
            </div>
          </div>
          {modalDefault.qrModal && (
            <QrModal setModalOpen={() => setModal("qrModal")} />
          )}
          {modalDefault.menuModal && (
            <div className="dropdown-menu">
              <div className="flex kuda-global--menu kuda-global--menu--mobile">
                <div className="global-menu--wrap global-display--wrap--mobile">
                  <div
                    className="closeModal"
                    style={{ top: "5px", left: "4px" }}
                    onClick={close}
                    dangerouslySetInnerHTML={{
                      __html:
                        '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.22178 8.22183C7.63599 8.80761 7.63599 9.75736 8.22178 10.3431L13.8786 16L8.22178 21.6569C7.63599 22.2426 7.63599 23.1924 8.22178 23.7782C8.80756 24.364 9.75731 24.364 10.3431 23.7782L16 18.1213L21.6568 23.7782C22.2426 24.364 23.1923 24.364 23.7781 23.7782C24.3639 23.1924 24.3639 22.2426 23.7781 21.6569L18.1213 16L23.7781 10.3431C24.3639 9.75736 24.3639 8.80761 23.7781 8.22183C23.1923 7.63604 22.2426 7.63604 21.6568 8.22183L16 13.8787L10.3431 8.22183C9.75731 7.63604 8.80756 7.63604 8.22178 8.22183Z" fill="#4D4D4D" style="mix-blend-mode:color-burn"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.22178 8.22183C7.63599 8.80761 7.63599 9.75736 8.22178 10.3431L13.8786 16L8.22178 21.6569C7.63599 22.2426 7.63599 23.1924 8.22178 23.7782C8.80756 24.364 9.75731 24.364 10.3431 23.7782L16 18.1213L21.6568 23.7782C22.2426 24.364 23.1923 24.364 23.7781 23.7782C24.3639 23.1924 24.3639 22.2426 23.7781 21.6569L18.1213 16L23.7781 10.3431C24.3639 9.75736 24.3639 8.80761 23.7781 8.22183C23.1923 7.63604 22.2426 7.63604 21.6568 8.22183L16 13.8787L10.3431 8.22183C9.75731 7.63604 8.80756 7.63604 8.22178 8.22183Z" fill="black" fill-opacity="0.4"/></svg>',
                    }}
                  ></div>
                  <div className="global-illustration title-bottom--spacing">
                    {renderIcon()}
                    {/* <img src={Global} alt="logo"/> */}
                  </div>
                  <div>
                    <div>
                      <p className="text-normal color-black title-bottom--spacing">
                        {renderText()}
                        {/* You’re currently on our Global page. */}
                      </p>
                      <p className="text-normal color-black">
                        Choose another country or region to see content specific
                        to your location or stay here.
                      </p>
                    </div>
                    <div
                      className="link-decoration cursor-pointer learn-more color-primary"
                      onClick={closeModal}
                    >
                      Stay Here
                    </div>
                  </div>
                </div>
                <ul className="kuda-dropdown--menu country-dropdown kuda-dropdown--menu--mobile">
                  {countries.map((item, index) => (
                    <li
                      key={index}
                      style={{
                        backgroundColor:
                          index === selected ? "rgb(151,151,151,0.1)" : "",
                      }}
                    >
                      {item.link ? (
                        <Link
                          aria-label={item.name}
                          exact="true"
                          href={item.link}
                          className="menu-link"
                          onClick={() => toggleActiveItem(index, item)}
                        >
                          {item.active === false ? (
                            <span className="lead-menu--item disabled">
                              <span className="menu-link--icon">
                                {item.img === true ? <Global /> : item.icon}
                              </span>
                              {item.name}
                            </span>
                          ) : (
                            <span className="lead-menu--item">
                              <span
                                className={
                                  "menu-link--icon" +
                                  `${selected === index ? " green-dot" : ""}`
                                }
                              >
                                {item.img === true ? <Global /> : item.icon}
                              </span>
                              {item.name}
                            </span>
                          )}
                          {item.active === false ? (
                            <span className="coming-soon">Coming Soon</span>
                          ) : (
                            ""
                          )}
                        </Link>
                      ) : (
                        <div aria-label={item.name} className="menu-link">
                          {item.active === false ? (
                            <span className="lead-menu--item disabled">
                              <span className="menu-link--icon">
                                {item.img === true ? <Global /> : item.icon}
                              </span>
                              {item.name}
                            </span>
                          ) : (
                            <span className="lead-menu--item">
                              <span
                                className={
                                  "menu-link--icon" +
                                  `${selected === index ? " green-dot" : ""}`
                                }
                              >
                                {item.img === true ? <Global /> : item.icon}
                              </span>
                              {item.name}
                            </span>
                          )}
                          {item.active === false ? (
                            <span className="coming-soon">Coming Soon</span>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>

        <div className="mobile-toggle" onClick={handleToggle}>
          <div className="kuda-hamburger">
            <div className="kuda-hamburger--inner"></div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default AuthHeaderLayout
